import { getAuthHeaders } from './auth';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

export const listContacts = async () => {
  const response = await fetch(`${API_URL}/contacts/list`, {
    method: 'GET',
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to fetch contacts');
  }

  return response.json();
};

export const importContacts = async (provider, contacts) => {
  const response = await fetch(`${API_URL}/contacts/import`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({ provider, contacts }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to import contacts');
  }

  return response.json();
};

// Returns { url } to send the user to for OAuth consent, or throws with the
// server's message (e.g. "not configured yet") if the provider isn't set up.
export const getContactsAuthUrl = async (provider) => {
  const response = await fetch(`${API_URL}/contacts/${provider}/auth-url`, {
    method: 'GET',
    headers: getAuthHeaders(),
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.error || 'This import is not available yet.');
  }
  return response.json();
};

export const addManualContact = async (email, name) => {
  const response = await fetch(`${API_URL}/contacts/add-manual`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({ email, phone: null, name }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to add contact');
  }

  return response.json();
};

export const removeContact = async (contactId) => {
  const response = await fetch(`${API_URL}/contacts/${contactId}`, {
    method: 'DELETE',
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to delete contact');
  }

  return response.json();
};
